import { createFileRoute } from "@tanstack/react-router";
import AddPaymentPage from "@/pages/payments/add-payment";
import PrivateLayout from "@/components/layouts/private-layout";
import { z } from "zod";

export const Route = createFileRoute("/_authenticated/payments/new")({
  component: RouteComponent,
  validateSearch: z.object({
    studentId: z.string().optional(),
  }),
});

function RouteComponent() {
  return (
    <PrivateLayout>
      <AddPaymentPage />
    </PrivateLayout>
  );
}
